export default {
  commonPapersize: 'Typowe rozmiary papieru',
  customerPapersize: 'Rozmiar papieru klienta',
};
